import PublicLandsOverlay from './PublicLandsOverlay';

export default PublicLandsOverlay;
